
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'financeNumber',
    standalone: false
})
export class FinanceNumberPipe implements PipeTransform {

    constructor(
        private currencyPipe: CurrencyPipe,
        private decimalPipe: DecimalPipe,
    ) { }

    transform(value: any, sign?: string, nullDisplay?: string): string {


        let transformed = nullDisplay ?? '―';

        if (value === null || value === undefined || Number.isNaN(value)) { return transformed; }

        const absoluteNumber = Math.abs(value);

        switch (sign) {
            case '$':
            case '£':
                transformed = this.currencyPipe.transform(absoluteNumber, sign, 'symbol', '1.0-2');
                break;
            case '%':
                transformed = `${this.decimalPipe.transform(absoluteNumber, '1.0-2')} %`;
                break;
            default:
                transformed = this.decimalPipe.transform(absoluteNumber, '1.0-2');
                break;
        }

        if (value < 0) {
            transformed = `(${transformed})`
        }

        return transformed;
    }
}

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        FinanceNumberPipe
    ],
    providers: [
        CurrencyPipe,
        DecimalPipe,
        FinanceNumberPipe,
    ],
    exports: [
        FinanceNumberPipe
    ],
})
export class FinanceNumberFormatPipeModule { }